import { render, staticRenderFns } from "./AdditionalProducts.vue?vue&type=template&id=7263a5b1&scoped=true"
import script from "./AdditionalProducts.vue?vue&type=script&lang=js"
export * from "./AdditionalProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7263a5b1",
  null
  
)

export default component.exports